import { render, staticRenderFns } from "./Spanish.vue?vue&type=template&id=498a521c&"
import script from "./Spanish.vue?vue&type=script&lang=js&"
export * from "./Spanish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports